import MuiRadio, { RadioProps } from '@mui/material/Radio';

export const Radio = (props: RadioProps) => {
  return <MuiRadio sx={{ padding: 0, mx: 1 }} {...props} />;
};
